export default "__VITE_ASSET__DOnsYUFo__"